// Deeplink Landing Page — constants
// Reference: TECHNICAL DESIGN DOCUMENT — Deeplink (Universal Link) Improvement v1.0

// --- Supported destinations (Section 1.2) ---
export const DESTINATIONS = {
  FUND_TAB: "fund_tab",
  FUND_INFO: "fund_info",
  ARTICLE: "article",
  OPEN_MF: "open_mf",
  OPEN_PVD: "open_pvd",
  SOFT_ONBOARD: "soft_onboard",
  FORGOT_CREDENTIALS: "forgot_credentials",
};

// Public destinations show Screen B fallback (with web link)
// Private destinations show Screen C fallback (download only, no web fallback)
export const PUBLIC_DESTINATIONS = [
  DESTINATIONS.FUND_TAB,
  DESTINATIONS.FUND_INFO,
  DESTINATIONS.ARTICLE,
];

// Anything not in PUBLIC_DESTINATIONS is treated as private (see
// isPublicDestination) — no separate list is needed.

// --- Platforms ---
export const PLATFORMS = {
  IOS: "ios",
  ANDROID: "android",
  DESKTOP: "desktop",
};

// --- Actions returned by /resolve (Section 4.1) ---
export const ACTIONS = {
  OPEN_APP: "open_app",
  OPEN_APP_LOGIN_FIRST: "open_app_login_first",
  REDIRECT_STORE: "redirect_store",
  REDIRECT_WEB: "redirect_web",
  SHOW_LANDING_PAGE: "show_landing_page",
};

// --- Screen states ---
// Per the agreed Figma design, mobile Screens A/B/C share an identical UI
// (spinner + "กรุณารอสักครู่..." + download link). The visual does not change
// based on whether the app is installed — that branch only affects whether
// the cpamapp:// scheme succeeds or the user must tap the download link.
export const SCREENS = {
  MOBILE_LANDING: "MOBILE",   // Mobile — Opening App / No App (same UI)
  DESKTOP_PUBLIC: "D",        // Desktop Public — QR landing
  DESKTOP_PRIVATE: "E",       // Desktop Private — QR landing
};

// --- UI strings (mobile landing) ---
// All three logical screens share these strings per the Figma design.
export const UI_STRINGS = {
  th: {
    headerAlliance: "In alliance with",
    langTh: "TH",
    langEn: "EN",
    title: "กรุณารอสักครู่...",
    subtitle: "กำลังเปิดแอป Principal TH!",
    downloadLink: "ดาวน์โหลด Principle TH app",
  },
  en: {
    headerAlliance: "In alliance with",
    langTh: "TH",
    langEn: "EN",
    title: "Please wait a moment...",
    subtitle: "Opening Principal TH!",
    downloadLink: "Download Principle TH app",
  },
};

// --- Firebase Analytics events (Section 3) ---
export const FIREBASE_EVENTS = {
  DEEPLINK_CLICK: "deeplink_click",
  CONTENT_VIEW: "content_view",
  APP_STORE_REDIRECT: "app_store_redirect",
  PRIVATE_JOURNEY_START: "private_journey_start",
  LOGIN_REQUIRED: "login_required",
  POST_LOGIN_CONVERSION: "post_login_conversion",
  QR_SCAN: "qr_scan",
  REGISTRATION_COMPLETE: "registration_complete",
};

// --- Custom URL scheme prefix ---
export const APP_SCHEME = "cpamapp://";

// --- Fallback timer for the app-scheme attempt (mobile, resolve-unavailable path) ---
// If the tab is still visible once this elapses, assume the app isn't
// installed and fall back to the store. See triggerAppScheme in utils.js for
// why the scheme attempt itself can't be made silent/safe on iOS.
//
// 1400ms, matching principal.codediva.co.th/deeplink.html — a reference
// implementation confirmed working on real devices. An earlier, more
// "sophisticated" version of this (visibilitychange/pagehide/blur listeners,
// an 800ms window, a late-fire heuristic) was intermittently unreliable in
// the field; this plain single-check version is what's actually proven out.
export const APP_OPEN_TIMEOUT_MS = 1400;

// --- App Store / Play Store URLs ---
// Official Principal TH listing IDs (confirmed):
//   iOS bundle id:     th.principal.principalth  → App Store id 1481176177
//   Android package:   th.principal.principalth
export const STORE_URLS = {
  IOS: "https://apps.apple.com/th/app/principal-th/id1481176177",
  ANDROID: "https://play.google.com/store/apps/details?id=th.principal.principalth",
};

// Screen D / E render their QR code and store badges from the desktop hero
// image (see ScreenDesktopPublic), so no QR-generation or web-fallback config
// is needed here.
